import React, { useState } from "react";
import api, { formatApiErrorDetail as fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { todayIso } from "@/lib/hr";

export function ExitDialog({ emp, onClose, onSaved }) {
  const [day, setDay] = useState(todayIso());
  const [reason, setReason] = useState("");
  const save = async () => {
    try { await api.post(`/hr/employees/${emp.user.id}/exit`, { last_working_day: day, reason }); toast.success(`${emp.user.name} marked as exited`); onSaved(); onClose(); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="exit-dialog">
        <DialogHeader><DialogTitle className="font-display">Mark {emp.user.name} as exited</DialogTitle>
          <DialogDescription>Their login is turned off right away. The final month is paid up to the last working day, later payroll runs leave them out, and past payslips stay available to HR.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label className="text-xs">Last working day</Label><Input type="date" value={day} onChange={(e) => setDay(e.target.value)} data-testid="exit-date-input" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Reason (optional, HR only)</Label><Textarea value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} data-testid="exit-reason-input" /></div>
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Cancel</Button><Button onClick={save} disabled={!day} className="bg-red-600 hover:bg-red-700" data-testid="exit-confirm-button">Mark as exited</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function RejoinDialog({ emp, onClose, onSaved }) {
  const [day, setDay] = useState(todayIso());
  const save = async () => {
    try { await api.post(`/hr/employees/${emp.user.id}/rejoin`, { rejoin_date: day }); toast.success(`${emp.user.name} is back on payroll`); onSaved(); onClose(); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="rejoin-dialog">
        <DialogHeader><DialogTitle className="font-display">Rejoin {emp.user.name}</DialogTitle>
          <DialogDescription>Their login is turned back on (same password) and they are paid from the rejoining date. Their saved salary structure is reused; review it if it changed.</DialogDescription></DialogHeader>
        <div className="space-y-1.5"><Label className="text-xs">Rejoining date</Label><Input type="date" value={day} onChange={(e) => setDay(e.target.value)} data-testid="rejoin-date-input" /></div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Cancel</Button><Button onClick={save} disabled={!day} className="bg-indigo-600 hover:bg-indigo-700" data-testid="rejoin-confirm-button">Rejoin</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
